import { Injectable } from '@angular/core';
import { MainService } from "./main.service";
import { HttpClient } from '@angular/common/http';
import { ToastService } from '../toast.service';
import { StorageService } from '../storage.service';
import { Router } from '@angular/router';

@Injectable({
  	providedIn: 'root'
})
export class WalletService extends MainService {

	wallet = null;

	constructor(
		public http: HttpClient,
		public toastService: ToastService,
		public storage: StorageService,
		public router: Router,
	) {
		super(http, toastService, storage, router);
	}

	getWallet(){
		let url = this.getStoreUrl('/V1/hnd-wallet/mine');
		this.doRequest(url, null, 'GET').then((data:any) => {
			if(!data.error && data.result){
				this.wallet = data.result;
			}
		});
	}
}
